(() => {
  'use strict';
  const $ = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => [...r.querySelectorAll(s)];

  // Header / mobile navigation — mirrors the HTML preview.
  const header = $('#siteHeader');
  const menuBtn = $('#menuBtn');
  const drawer = $('#drawer');
  const syncHeader = () => header?.classList.toggle('scrolled', window.scrollY > 20);
  window.addEventListener('scroll', syncHeader, {passive:true});
  syncHeader();
  menuBtn?.addEventListener('click', () => {
    const open = !drawer?.classList.contains('active');
    drawer?.classList.toggle('active', open);
    drawer?.classList.toggle('mab-open', open);
    drawer?.setAttribute('aria-hidden', open ? 'false' : 'true');
    menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('menu-open', open);
  });
  drawer && $$('a', drawer).forEach(a => a.addEventListener('click', () => {
    drawer.classList.remove('active','mab-open');
    drawer.setAttribute('aria-hidden','true');
    menuBtn?.setAttribute('aria-expanded','false');
    document.body.classList.remove('menu-open');
  }));

  // Reveal animation.
  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        revealObserver.unobserve(entry.target);
      }
    });
  }, {threshold:.06, rootMargin:'0px 0px -25px'}) : null;
  $$('.reveal').forEach(el => revealObserver ? revealObserver.observe(el) : el.classList.add('in'));

  // Before / after comparison.
  const compareInput = $('#compareInput');
  const compareTop = $('#compareTop');
  const compareHandle = $('#compareHandle');
  const afterImage = $('#afterImage');
  const afterLabel = $('#afterLabel');
  const compareWrap = $('#compareWrap');
  const syncCompareWidth = () => compareWrap?.style.setProperty('--compare-media-width', compareWrap.getBoundingClientRect().width + 'px');
  const setCompare = value => {
    if (compareTop) compareTop.style.width = value + '%';
    if (compareHandle) compareHandle.style.left = value + '%';
  };
  compareInput?.addEventListener('input', e => setCompare(e.target.value));
  window.addEventListener('resize', syncCompareWidth, {passive:true});
  syncCompareWidth();
  $$('.style-tab').forEach(tab => tab.addEventListener('click', () => {
    $$('.style-tab').forEach(t => t.classList.remove('active'));
    tab.classList.add('active');
    if (afterImage) {
      afterImage.style.opacity = '.16';
      window.setTimeout(() => {
        afterImage.src = tab.dataset.after || afterImage.src;
        afterImage.alt = 'After ' + (tab.dataset.label || '') + ' lashes';
        afterImage.style.opacity = '1';
        syncCompareWidth();
      }, 150);
    }
    if (afterLabel) afterLabel.textContent = tab.dataset.label || '';
    setCompare(50);
    if (compareInput) compareInput.value = 50;
  }));

  // UGC rail + playback.
  const videos = $$('.ugc-card video');
  if ('IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver(entries => entries.forEach(({target,isIntersecting}) => {
      if (isIntersecting) target.play().catch(() => {}); else target.pause();
    }), {threshold:.45});
    videos.forEach(v => videoObserver.observe(v));
  }
  $$('.ugc-card').forEach(card => {
    const video = $('video', card), play = $('.play-toggle', card), mute = $('.mute-toggle', card);
    play?.addEventListener('click', () => { if (video) video.paused ? video.play().catch(()=>{}) : video.pause(); });
    mute?.addEventListener('click', () => { if (!video) return; video.muted = !video.muted; mute.style.opacity = video.muted ? '1' : '.55'; });
  });
  const ugcRail = $('#ugcRail');
  const railStep = () => { const card = ugcRail && $('.ugc-card', ugcRail); return card ? card.getBoundingClientRect().width + 15 : 300; };
  $('#ugcPrev')?.addEventListener('click', () => ugcRail?.scrollBy({left:-railStep(),behavior:'smooth'}));
  $('#ugcNext')?.addEventListener('click', () => ugcRail?.scrollBy({left:railStep(),behavior:'smooth'}));

  // Shopify Ajax cart, rendered into the preview drawer.
  const cartDrawer = $('#cartDrawer');
  const cartOverlay = $('#cartOverlay');
  const cartItems = $('[data-mab-cart-items]');
  const cartSubtotal = $('[data-mab-cart-subtotal]');
  const cartCountEls = $$('[data-mab-cart-count]');
  const shippingCopy = $('[data-mab-shipping-copy]');
  const progress = $('[data-mab-progress-fill]');
  const thresholdEl = $('.cart-progress');
  const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const currency = window.Shopify?.currency?.active || 'EUR';
  const money = cents => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}).format((Number(cents)||0)/100); }
    catch(e) { return ((Number(cents)||0)/100).toFixed(2) + ' ' + currency; }
  };
  const escapeHtml = text => String(text ?? '').replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));

  function renderCart(cart) {
    cartCountEls.forEach(el => el.textContent = cart.item_count || 0);
    if (cartSubtotal) cartSubtotal.textContent = money(cart.total_price);
    if (cartItems) {
      const empty = cartDrawer?.dataset.emptyLabel || 'Your cart is empty.';
      if (!cart.items?.length) {
        cartItems.innerHTML = `<p class="mab-cart-empty">${escapeHtml(empty)}</p>`;
      } else {
        cartItems.innerHTML = cart.items.map((item, index) => `
          <div class="cart-item" data-line="${index + 1}">
            <div class="cart-item-img">${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}">` : ''}</div>
            <div>
              <p class="cart-item-name">${escapeHtml(item.product_title)}</p>
              <p class="cart-item-meta">${escapeHtml(item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '')}</p>
              <div class="cart-qty"><button type="button" data-cart-qty="${index+1}" data-qty="${Math.max(0,item.quantity-1)}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-cart-qty="${index+1}" data-qty="${item.quantity+1}" aria-label="Increase quantity">+</button></div>
            </div>
          </div>`).join('');
        $$('[data-cart-qty]', cartItems).forEach(btn => btn.addEventListener('click', async () => {
          await changeLine(btn.dataset.cartQty, btn.dataset.qty);
        }));
      }
    }
    const threshold = Number(thresholdEl?.dataset.threshold || 0);
    if (threshold > 0) {
      const pct = Math.max(0, Math.min(100, (cart.total_price / threshold) * 100));
      if (progress) progress.style.width = pct + '%';
      if (shippingCopy) {
        if (cart.total_price >= threshold) shippingCopy.textContent = cartDrawer?.dataset.freeUnlocked || 'You unlocked free shipping.';
        else shippingCopy.textContent = money(threshold - cart.total_price) + ' ' + (cartDrawer?.dataset.freeAway || 'away from free shipping.');
      }
    }
  }
  async function fetchCart() {
    const r = await fetch(root + 'cart.js', {headers:{'Accept':'application/json'}});
    if (!r.ok) throw new Error('Cart request failed');
    const cart = await r.json(); renderCart(cart); return cart;
  }
  function showCart() {
    cartDrawer?.classList.add('active','mab-open');
    cartOverlay?.classList.add('active','mab-open');
    cartDrawer?.setAttribute('aria-hidden','false');
    document.body.classList.add('cart-open');
  }
  function closeCart() {
    cartDrawer?.classList.remove('active','mab-open');
    cartOverlay?.classList.remove('active','mab-open');
    cartDrawer?.setAttribute('aria-hidden','true');
    document.body.classList.remove('cart-open');
  }
  async function openCart() { try { await fetchCart(); } catch(e) {} showCart(); }
  async function addVariant(id, quantity=1) {
    if (!id) { await openCart(); return; }
    const r = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:Number(quantity)||1}]})});
    if (!r.ok) { await openCart(); return; }
    await fetchCart(); showCart();
  }
  async function changeLine(line, quantity) {
    const r = await fetch(root + 'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:Number(line),quantity:Number(quantity)})});
    if (r.ok) renderCart(await r.json());
  }
  $('#cartOpenLink')?.addEventListener('click', e => { e.preventDefault(); openCart(); });
  $('#cartClose')?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeCart(); drawer?.classList.remove('active','mab-open'); document.body.classList.remove('menu-open'); } });
  $$('.add-btn,.style-mobile-add').forEach(btn => btn.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); addVariant(btn.dataset.variantId); }));
  $('#upsellAdd')?.addEventListener('click', e => addVariant(e.currentTarget.dataset.variantId));

  // Mood finder.
  const moodImage = $('#moodImage'), moodCaption = $('#moodCaption'), moodProduct = $('#moodProduct'), moodDesc = $('#moodDesc'), moodAdd = $('#moodAdd');
  $$('.mood-option').forEach(opt => opt.addEventListener('click', () => {
    $$('.mood-option').forEach(x => x.classList.remove('active')); opt.classList.add('active');
    if (moodImage) { moodImage.style.opacity='.18'; setTimeout(() => { moodImage.src = opt.dataset.moodImg || moodImage.src; moodImage.style.opacity='1'; },150); }
    if (moodCaption) moodCaption.textContent = opt.dataset.caption || '';
    if (moodProduct) moodProduct.textContent = opt.dataset.product || '';
    if (moodDesc) moodDesc.textContent = opt.dataset.desc || '';
    if (moodAdd) moodAdd.dataset.variantId = opt.dataset.variantId || '';
  }));
  moodAdd?.addEventListener('click', () => addVariant(moodAdd.dataset.variantId));

  // Scroll-led How It Works activation.
  const howSteps = $$('.how-story-step'), howProgress = $$('.how-progress-item');
  if (howSteps.length && 'IntersectionObserver' in window) {
    const howObserver = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) {
        const idx = Number(entry.target.dataset.step || 0);
        howSteps.forEach((s,i) => s.classList.toggle('active',i===idx));
        howProgress.forEach((p,i) => p.classList.toggle('active',i===idx));
      }
    }), {threshold:.52,rootMargin:'-10% 0px -20% 0px'});
    howSteps.forEach(s => howObserver.observe(s));
  }

  // Smooth single-open FAQ accordion from the preview.
  const faq = $('.faq-list');
  if (faq) {
    const items = $$('details', faq); const duration=420;
    const closeItem = item => {
      if (!item.open) return; const answer=$('p',item); if (!answer) {item.open=false;return;}
      answer.style.maxHeight=answer.scrollHeight+'px'; answer.getBoundingClientRect(); answer.style.maxHeight='0px'; answer.style.opacity='0';
      setTimeout(()=>{item.open=false;answer.style.maxHeight='';answer.style.opacity='';},duration);
    };
    const openItem = item => { items.forEach(other=>{if(other!==item&&other.open)closeItem(other)}); const answer=$('p',item); if(!answer){item.open=true;return;} item.open=true;answer.style.maxHeight='0px';answer.style.opacity='0';requestAnimationFrame(()=>requestAnimationFrame(()=>{answer.style.maxHeight=answer.scrollHeight+'px';answer.style.opacity='1';})); };
    items.forEach(item => { const summary=$('summary',item), answer=$('p',item); if(answer)answer.style.maxHeight=item.open?answer.scrollHeight+'px':'0px'; summary?.addEventListener('click',e=>{e.preventDefault();item.open?closeItem(item):openItem(item);}); });
    window.addEventListener('resize',()=>items.forEach(item=>{if(item.open){const a=$('p',item);if(a)a.style.maxHeight=a.scrollHeight+'px';}}));
  }

  // V35/V38 mobile conversion behavior.
  const isMobile = () => window.matchMedia('(max-width: 767px)').matches;
  $$('#styles .style-image').forEach(img => img.addEventListener('click', () => { if (isMobile()) img.closest('.style-card')?.classList.toggle('mobile-alt'); }));
  const buyBar = $('#mobileBuyBar'), hero = $('.hero'), footer = $('.footer');
  const updateBuyBar = () => {
    if (!buyBar || !hero || !isMobile()) { buyBar?.classList.remove('visible'); return; }
    const shouldShow = hero.getBoundingClientRect().bottom < 140 && (!footer || footer.getBoundingClientRect().top > window.innerHeight*.72);
    buyBar.classList.toggle('visible',shouldShow); buyBar.setAttribute('aria-hidden',shouldShow?'false':'true');
  };
  window.addEventListener('scroll',updateBuyBar,{passive:true}); window.addEventListener('resize',updateBuyBar); updateBuyBar();
})();
